<div (mouseenter)="onSidebarHover()" (mouseleave)="onSidebarLeave()">
<!--  <div class="main-header-left d-none d-lg-block">-->
<!--    <div class="logo-wrapper d-flex justify-content-center">-->
<!--      <img (click)="navigateToDefaultPages()" alt="" class="blur-up lazyloaded" src="assets/images/{{logo}}" style="width: auto; height: 34px;">-->
<!--    </div>-->
<!--  </div>-->
  <div class="sidebar custom-scrollbar">
    <div class="sidebar-user text-center">
      <div>
        <img class="img-60 rounded-circle" *ngIf="profile == '' || !profile" src="assets/images/ristaschool/school-default.png"  alt="">
        <img class="img-60 rounded-circle" *ngIf="profile != '' && profile && !listCheck"  src="{{imgUrl +'/'+ profile}}"  alt="">
        <img class="img-60 rounded-circle" *ngIf="profile && profile != '' && listCheck" [src]="profile"  alt="">
      </div>
<!--      <h6 class="mt-2 f-14" *ngIf="['3', '6'].includes(role) && sideBarOpened">{{name}}</h6>-->
<!--      <h6 class="f-12" *ngIf="role == 6 && sideBarOpened">({{corporateCode}})</h6>-->
<!--      <div class="row" *ngIf="['2', '4', '5'].indexOf(role) > -1 && sideBarOpened">-->
<!--        <select *ngIf="schoolName.length > 1" [disabled]="!allowSelect" class="form-control w-75 mt-3 ml-4" (change)="schoolChangeList($event.target.value)" [(ngModel)]="sclName">-->
<!--          <option *ngFor="let school of schoolName" [value]="school.school_id">{{school.name}}</option>-->
<!--        </select>-->
<!--        <h6 *ngIf="schoolName.length == 1" class="contenttext col-12 mt-3">{{schoolName[0].name}}</h6>-->
<!--      </div>-->
<!--      <div *ngIf="overallData != '' && sideBarOpened">-->
<!--        <div class="row" *ngIf="role == 6 && !hideSchoolDropdown">-->
<!--          <select *ngIf="schoolName.length > 1" [disabled]="!allowSelect" class="form-control w-75 mt-3 ml-4" (change)="schoolChangeList($event.target.value)" [(ngModel)]="sclName">-->
<!--            <option *ngFor="let school of schoolName; let i = index"  [value]="school.school_id">{{school.name}}</option>-->
<!--          </select>-->
<!--          <h6 *ngIf="schoolName.length == 1" class="contenttext col-12 mt-3">{{schoolName[0].name}}</h6>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <ul class="sidebar-menu" (click)="removeSessionData()">
      <li *ngFor="let menuItem of updatedMenuItems; let i = index" class="nav-li-with-flyout" [ngClass]="{active: menuItem.active}"
          (mouseenter)="onSubmenuEnter(menuItem, i, $event)"
          (mouseleave)="scheduleSubmenuClose()">
        <!-- Sub -->
        <a [title]="menuItem.title" href="javascript:void(0)" class="sidebar-header nav-item-vertical" *ngIf="menuItem.type === 'sub'"
           (click)="toggletNavActive(menuItem , 'sub')">
          <span class="nav-item-content">
            <span class="nav-icon-wrap"><app-feather-icons [icon]="menuItem.icon"></app-feather-icons></span>
            <span class="nav-label">{{menuItem.title}}<span class="badge badge-{{menuItem.badgeType}} nav-badge" *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
          </span>
<!--          <i class="fa fa-angle-right pull-right nav-arrow" *ngIf="menuItem.children"></i>-->
        </a>
        <!-- Link -->
        <a [title]="menuItem.title" [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active" class="sidebar-header nav-item-vertical"
           [ngStyle]="{'color': menuItem.active ? '#8F008A' : ''}"  [ngClass]="{active: menuItem.active}" *ngIf="menuItem.type === 'link'" (click)="toggletNavActive(menuItem, 'link')">
          <span class="nav-item-content">
            <span class="nav-icon-wrap" *ngIf="menuItem.title != 'Announcements'"><app-feather-icons [icon]="menuItem.icon"></app-feather-icons></span>
            <span class="nav-icon-wrap" *ngIf="menuItem.title == 'Announcements'"><i class="fa fa-bullhorn nav-icon-fa"></i></span>
            <span class="nav-label">{{menuItem.title}}<span class="badge badge-{{menuItem.badgeType}} nav-badge" *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
          </span>
<!--          <i class="fa fa-angle-right pull-right nav-arrow" *ngIf="menuItem.children"></i>-->
        </a>
        <!-- Fly-out submenu to the right on hover -->
        <div class="sidebar-flyout" *ngIf="menuItem.children && submenuHoverIndex === i" [ngStyle]="{ top: flyoutTop + 'px', left: flyoutLeft + 'px' }"
             (mouseenter)="onSubmenuFlyoutEnter(i)" (mouseleave)="scheduleSubmenuClose()">
          <ul class="sidebar-flyout-menu">
            <li *ngFor="let childrenItem of menuItem.children; let childIndex = index" [ngClass]="{active: childrenItem.active}">
              <a [title]="childrenItem.title" href="javascript:void(0)" *ngIf="childrenItem.type === 'sub'" (click)="toggletNavActive(childrenItem, 'sub')">
                <i class="fa fa-{{childrenItem.icon}} flyout-icon-fa pr-2"></i>
                <span>{{childrenItem.title}}</span>
              </a>
              <a [title]="childrenItem.title" [routerLink]="!childrenItem.type ? null : [childrenItem.path]" *ngIf="childrenItem.type === 'link'"
                 routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleSubMenu(childrenItem, menuItem, childIndex)">
                <i class="fa fa-{{childrenItem.icon}} flyout-icon-fa pr-2"></i>
                <span>{{childrenItem.title}}</span>
              </a>
              <a [title]="childrenItem.title" href="{{ !childrenItem.type ? null : childrenItem.path }}" *ngIf="childrenItem.type === 'extLink'"
                 routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-{{childrenItem.icon}} flyout-icon-fa pr-2"></i>
                <span>{{childrenItem.title}}</span>
              </a>
              <a [title]="childrenItem.title" href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank"
                 *ngIf="childrenItem.type === 'extTabLink'">
                <i class="fa fa-{{childrenItem.icon}} flyout-icon-fa pr-2"></i>
                <span>{{childrenItem.title}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-li-with-flyout" *ngIf="auth.showBackToAdminMenu">
        <a title="Back To Admin Login" class="sidebar-header nav-item-vertical" (click)="auth.backToAdmin()">
          <span class="nav-item-content">
            <span class="nav-icon-wrap"><i class="fa fa-long-arrow-left"></i></span>
            <span class="nav-label">Back To Admin Login</span>
          </span>
        </a>
      </li>
      <div class="mt-2 sidebar-version">
        <p class="nav-label text-center">{{version}}</p>
      </div>
    </ul>
  </div>
</div>
